import { useTranslation } from 'react-i18next';
import React from 'react'
import { message, Modal, Select, Row, Col, InputNumber, Input } from 'antd'
import { getPcodeDict, getUserBtn } from '@/utils/dataStorage'
import { orderCancelReview, orderReject, organDispatch, exportOrderData, exportOrderDetailData, orderMaintenanceComplete } from '@/service/ordersService'
import { getUserCustomizeConfigOne } from '@/service/settings'
import i18n from 'i18next';
const { Option } = Select

const activeMenuOrderStatus = {
    ordersManage: ['pending_labor', 'pending_departure', 'already_departure', 'in_maintenance', 'tobe_confirmed'],
    allOrder: [],
    pendingOrder: ['pending_order'],
    paymentOrder: ['pending_payment'],
    reviewOrder: ['pending_system_review'],
    cancelleOrder: ['cancelled'],
    completeOrder: ['completed'],
}
//作废工单
export const cancellationOrder = async (selectInfo, loadData, searchValue) => {
    if (!Object.keys(selectInfo.rowInfo).length) {
        message.warning(i18n.t(`ordersManage.ordersManage.orderListCommon.请选择你要作废的工单`))
        return
    }
    if (selectInfo.rowInfo.orderStatus === 'cancelled') {
        message.warning(i18n.t(`ordersManage.ordersManage.orderListCommon.该工单状态已是作废`))
        return
    }
    let orderCancelReason = '' //记录工单作废原因
    Modal.confirm({
        title: i18n.t(`ordersManage.ordersManage.orderListCommon.请选择取消工单的原因`),
        content: (
            <Select
                showSearch
                placeholder= {i18n.t(`ordersManage.ordersManage.orderListCommon.请选择取消工单的原因`)}
                optionFilterProp="children"
                onChange={(value) => {
                    orderCancelReason = value
                }}
                style={{ width: '200px' }}
            >
                {getPcodeDict('041').children.map((item) => (
                    <Option value={item.dictCode} key={item.id}>
                        {item.title}
                    </Option>
                ))}
            </Select>
        ),
        okText: i18n.t(`ordersManage.ordersManage.orderListCommon.确定`),
        cancelText: i18n.t(`ordersManage.ordersManage.orderListCommon.取消`),
        onOk: () => {
            return new Promise((resolve, reject) => {
                if (orderCancelReason) {
                    resolve(orderCancelReason)
                } else {
                    message.warning(i18n.t(`ordersManage.ordersManage.orderListCommon.请输入工单作废的原因`))
                    reject(i18n.t(`ordersManage.ordersManage.orderListCommon.请输入工单作废的原因`))
                }
            }).then((res) => {
                let data = {
                    submitReason: res,
                    orderId: selectInfo.rowInfo.id,
                }
                orderCancelReview(data).then((res) => {
                    loadData(1, searchValue)
                    message.success(i18n.t(`ordersManage.ordersManage.orderListCommon.本条工单已申请作废`))
                })
            })
        },
        onCancel: () => {},
    })
}

//机构派单
export const handleDispatchOrgan = (selectInfo, allOrg, loadData, searchValue) => {
    if (!Object.keys(selectInfo.rowInfo).length) {
        message.warning(i18n.t(`ordersManage.ordersManage.orderListCommon.请选择你要派单的工单`))
        return
    }
    let organId = ''
    let clearTeam = false
    Modal.confirm({
        title: i18n.t(`ordersManage.ordersManage.orderListCommon.选择转派的机构`),
        content: (
            <Row>
                <Col span={24}>
                    {/* <span style={{ display: 'inline-block', width: '100px', textAlign: 'right', marginRight: '10px' }}> {i18n.t(`ordersManage.ordersManage.orderListCommon.请选择机构`)}:</span> */}
                    <Select
                        showSearch
                        placeholder= {i18n.t(`ordersManage.ordersManage.orderListCommon.请选择机构`)}
                        optionFilterProp="children"
                        onChange={(value) => {
                            organId = value
                        }}
                        style={{ width: '100%' }}
                    >
                        {allOrg.map((item) => (
                            <Option value={item.id} key={item.id}>
                                {item.organName}
                            </Option>
                        ))}
                    </Select>
                </Col>
                
            </Row>
        ),
        okText: i18n.t(`ordersManage.ordersManage.orderListCommon.确定`),
        cancelText: i18n.t(`ordersManage.ordersManage.orderListCommon.取消`),
        onOk: () => {
            let data = {
                organId,
                clearTeam,
                orderId: selectInfo.rowInfo.id,
            }
            organDispatch(data).then((res) => {
                loadData(1, searchValue)
                message.success(res.retData)
            })
        },
        onCancel: () => {},
    })
}


export const handlePrint = (selectInfo, setPrintVisible) => {
    if (!Object.keys(selectInfo.rowInfo).length) {
        message.warning(i18n.t(`ordersManage.ordersManage.orderListCommon.请选择你要打印的工单`))
        return
    }
    setPrintVisible({ visible: true, orderId: selectInfo.rowInfo.id })
}

export const handleSettleScaniaPrint = async (selectInfo, setPrintSettleScaniaVisible) => {
    if (!Object.keys(selectInfo.rowInfo).length) {
        message.warning(i18n.t(`ordersManage.ordersManage.orderListCommon.请选择你要打印的工单`))
        return
    }
    if (!selectInfo.rowInfo.ciBusinessEntityName) {
        message.warning(i18n.t(`ordersManage.ordersManage.orderListCommon.请选择完善工单实体后打印`))
        return
    }
    // let printNum = '1'
    // try {
    //     let printModelList = await getUserCustomizeConfigOne('printModel')
    //     if (printModelList && printModelList.retCode == 200) {
    //         printNum=printModelList.retData.val
    //     } else {
    //         message.warning('没有获取到用户打印门店，使用默认门店')
    //         printNum='1'
    //     }
    //     // }
    // } catch (error) {
    //     message.warning('没有获取到用户打印门店，使用默认门店')
    //     printNum=1
    // }
    // setPrintSettleScaniaVisible({ visible: true, orderId: selectInfo.rowInfo.id,printNum })
    setPrintSettleScaniaVisible({ visible: true, orderId: selectInfo.rowInfo.id })
}

export const snkyPrint = async (selectInfo, setPrintSnkyVisible, type = 1) => {
    if (!Object.keys(selectInfo.rowInfo).length) {
        message.warning(i18n.t(`ordersManage.ordersManage.orderListCommon.请选择你要打印的工单`))
        return
    }
    if (!selectInfo.rowInfo.ciBusinessEntityName) {
        message.warning(i18n.t(`ordersManage.ordersManage.orderListCommon.请选择完善工单实体后打印`))
        return
    }
    // let printNum = '1'
    // try {
    //     let printModelList = await getUserCustomizeConfigOne('printModel')
    //     if (printModelList && printModelList.retCode == 200) {
    //         printNum=printModelList.retData.val
    //     } else {
    //         message.warning('没有获取到用户打印门店，使用默认门店')
    //         printNum='1'
    //     }
    //     // }
    // } catch (error) {
    //     message.warning('没有获取到用户打印门店，使用默认门店')
    //     printNum=1
    // }
    setPrintSnkyVisible({ visible: true, orderId: selectInfo.rowInfo.id, type })
}

export const butResourceApply = (str) => {
    let resource = getUserBtn('ordersManage') || {}
    resource = resource.children || []
    return resource.find((item) => item.path === str) ? true : false
}


export const exportOrderDetailed = async (columns, searchValue, activeMenu = 'ordersManage', selectInfo) => {
    const tables = columns.map((item) => {
        return {
            title: item.title,
            key: item.dataIndex,
        }
    })
    let data = {
        type: 'post',
        data: {
            startTime: searchValue.startTime ? searchValue.startTime : null,
            endTime: searchValue.endTime ? searchValue.endTime : null,
            searchItem: {
                ...searchValue,
                tables,
                orderStatus: searchValue.orderStatus ? [searchValue.orderStatus] : activeMenuOrderStatus[activeMenu],
                ids: selectInfo.selectedRowKeys,
            },
            orders: [
                {
                    column: 'updateTime',
                    rule: 'DESC',
                },
            ],
        },
    }
    //导出记录去查看
    exportOrderDetailData(data.data).then((res) => {
        message.success(res.retData)
    })
}

export const exportOrder = async (columns, searchValue, activeMenu = 'ordersManage', selectInfo) => {
    const tables = columns.map((item) => {
        return {
            title: item.title,
            key: item.dataIndex,
        }
    })
    let data = {
        type: 'post',
        data: {
            startTime: searchValue.startTime ? searchValue.startTime : null,
            endTime: searchValue.endTime ? searchValue.endTime : null,
            searchItem: {
                ...searchValue,
                tables,
                orderStatus: searchValue.orderStatus ? [searchValue.orderStatus] : activeMenuOrderStatus[activeMenu],
                ids: selectInfo.selectedRowKeys,
            },
            orders: [
                {
                    column: 'updateTime',
                    rule: 'DESC',
                },
            ],
        },
    }
    //导出记录去查看
    exportOrderData(data.data).then((res) => {
        message.success(res.retData)
    })
}


export const handleDispatchOrder = (status, selectInfo, setShowOrderDispatchVisible) => {
    if (!Object.keys(selectInfo.rowInfo).length) {
        message.warning(i18n.t(`ordersManage.ordersManage.orderListCommon.请选择你要派单的工单`))
        return
    }
    setShowOrderDispatchVisible(status || true)
}


export const reviewRecord = (selectInfo, setReviewInfo) => {
    if (!selectInfo.rowInfo.id) {
        message.warning(i18n.t(`ordersManage.ordersManage.orderListCommon.请选择你要查看的工单`))
        return
    }
    setReviewInfo({ visible: true, orderId: selectInfo.rowInfo.id })
}


export const repairComplete = (selectInfo, loadData, searchValue) => {
    if (!selectInfo.rowInfo.id) {
        message.warning(i18n.t(`ordersManage.ordersManage.orderListCommon.请选择你要查看的工单`))
        return
    }
    let processResult = '',
        customerVehicleMileage = ''
    Modal.confirm({
        title: `${i18n.t(`ordersManage.ordersManage.orderListCommon.温馨提示`)}:${i18n.t(`ordersManage.ordersManage.orderListCommon.维修完成后，不能再修改配件`)}`,
        content: (
            <>
                <Input
                    placeholder= {i18n.t(`ordersManage.ordersManage.orderListCommon.请输入处理结果`)}
                    onChange={(e) => {
                        processResult = e.target.value
                    }}
                    style={{ marginBottom: '10px' }}
                />
                <InputNumber
                    placeholder= {i18n.t(`ordersManage.ordersManage.orderListCommon.请输入车辆行驶里程`)}
                    style={{ width: '100%' }}
                    min={0}
                    onChange={(e) => {
                        console.log(e)
                        customerVehicleMileage = e
                    }}
                />
            </>
        ),
        okText: i18n.t(`ordersManage.ordersManage.orderListCommon.确定`),
        cancelText: i18n.t(`ordersManage.ordersManage.orderListCommon.取消`),
        onOk: () => {
            return new Promise((resolve, reject) => {
                if (processResult && customerVehicleMileage) {
                    resolve({ processResult, customerVehicleMileage })
                } else {
                    message.warning(i18n.t(`ordersManage.ordersManage.orderListCommon.请输入处理结果和车辆行驶里程`))
                    reject(i18n.t(`ordersManage.ordersManage.orderListCommon.请输入处理结果和车辆行驶里程`))
                }
            }).then((res) => {
                const { processResult, customerVehicleMileage } = res
                let data = { processResult, customerVehicleMileage, orderId: selectInfo.rowInfo.id }
                console.log(data)
                orderMaintenanceComplete(data).then((res) => {
                    loadData(1, searchValue)
                    message.success(i18n.t(`ordersManage.ordersManage.orderListCommon.工单已维修完成`))
                })
            })
        },
        onCancel: () => {},
    })
}


export const rejectOrder = (selectInfo, loadData, searchValue) => {
    if (!selectInfo.rowInfo.id) {
        message.warning(i18n.t(`ordersManage.ordersManage.orderListCommon.请选择你要驳回的工单`))
        return
    }
    if (selectInfo.rowInfo.orderStatus === 'pending_system_review') {
        let str = '' //记录工单驳回原因
        Modal.confirm({
            title: i18n.t(`ordersManage.ordersManage.orderListCommon.请输入驳回工单的原因`),
            content: (
                <Input
                    placeholder= {i18n.t(`ordersManage.ordersManage.orderListCommon.请输入工单驳回的原因`)}
                    onChange={(e) => {
                        str = e.target.value
                    }}
                />
            ),
            okText: i18n.t(`ordersManage.ordersManage.orderListCommon.确定`),
            cancelText: i18n.t(`ordersManage.ordersManage.orderListCommon.取消`),
            onOk: () => {
                return new Promise((resolve, reject) => {
                    if (str) {
                        resolve(str)
                    } else {
                        message.warning(i18n.t(`ordersManage.ordersManage.orderListCommon.请输入工单驳回的原因`))
                        reject(i18n.t(`ordersManage.ordersManage.orderListCommon.请输入工单驳回的原因`))
                    }
                }).then((res) => {
                    orderReject({
                        orderId: selectInfo.rowInfo.id,
                        rejectInfo: res,
                    }).then((res) => {
                        loadData(1, searchValue)
                        message.success(i18n.t(`ordersManage.ordersManage.orderListCommon.驳回成功`))
                    })
                })
            },
            onCancel: () => {},
        })
    } else {
        message.warning(i18n.t(`ordersManage.ordersManage.orderListCommon.错误。当前订单不是待审核状态。无法进行驳回操作`))
    }
}
